import Toggle from 'components/Toggle'
import _ from 'lodash'
import * as QRCode from 'qrcode'
import React, {useEffect, useState,} from 'react'
import classNames from "classnames";

export const QRComponent = ({
                                id,
                                encode,
                                visible = true,
                                defaultMaxSize = 160,
    className,
                                ...props
                            }) => {
    const _max = defaultMaxSize
    const _min = visible ? _max : 40
    const [canvas, setCanvas] = useState()

    const [size, setSize] = useState(_min)

    useEffect(() => {
        QRCode.toCanvas(
            encode,
            {
                width: size,
                margin: 2,
                errorCorrectionLevel: 'M',
            },
            (error, canvas) => {
                if (error) console.error(error)
                const container =
                    document.getElementById(
                        'qr_canvas' + id
                    )
                if (container) {
                    while (container.firstChild) {
                        container.removeChild(
                            container.firstChild
                        )
                    }
                }
                container.appendChild(canvas)
                setCanvas(canvas)
            }
        )
    }, [size])

    if (_.isEmpty(encode)) {
        return null
    }

    return (
        <div className={classNames("click-zoom", className)}>
            <Toggle isToggle={!!visible}>
                {(isToggle, toggle) => {
                    const _toggle = () => {
                        if (!!visible) return
                        if (isToggle) {
                            setSize(_min)
                        } else {
                            setSize(_max)
                        }
                        toggle()
                    }

                    return (
                        <label>
                            <div
                                id={"qr_canvas" + id}
                                style={{zIndex: 7, padding: 2}}
                                className="flex border rounded-md bg-white"
                            />
                        </label>
                    )
                }}
            </Toggle>
        </div>
    )
}
